import React from "react";
import { Select, TimePicker, Button } from "antd";
import dayjs from "dayjs";

const { Option } = Select;

export default function BookingSidebar({ config, setConfig, onNext }) {
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const handleTimeChange = (day, field, value) => {
    const newAvail = { ...config.availability };
    if (!newAvail[day]) newAvail[day] = { available: true };
    newAvail[day][field] = value ? value.format("HH:mm") : "";
    setConfig({ ...config, availability: newAvail });
  };

  return (
    <div className="w-full lg:w-80 bg-white border-r border-gray-200 h-full flex flex-col">
      <div className="p-5 border-b">
        <h2 className="text-lg font-semibold text-gray-900">
          Bookable Appointment Schedule
        </h2>
        <input
          type="text"
          placeholder="Add title"
          value={config.title}
          onChange={(e) => setConfig({ ...config, title: e.target.value })}
          className="mt-2 w-full border rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
        />
      </div>

      <div className="flex-1 overflow-y-auto p-5 space-y-6">
        {/* Appointment Duration */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Appointment duration
          </label>
          <p className="text-xs text-gray-500 mb-2">
            How long should each appointment last?
          </p>
          <Select
            value={config.duration}
            onChange={(val) => setConfig({ ...config, duration: val })}
            className="w-full"
          >
            <Option value={30}>30 minutes</Option>
            <Option value={60}>1 hour</Option>
            <Option value={90}>1.5 hours</Option>
            <Option value={120}>2 hours</Option>
          </Select>
        </div>

        {/* Availability */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            General availability
          </label>
          <Select
            value={config.repeatWeekly ? "weekly" : "custom"}
            onChange={(v) => setConfig({ ...config, repeatWeekly: v === "weekly" })}
            className="w-full mb-3"
          >
            <Option value="weekly">Repeat weekly</Option>
            <Option value="custom">Custom</Option>
          </Select>

          <div className="space-y-2">
            {days.map((day) => {
              const avail = config.availability[day];
              return (
                <div
                  key={day}
                  className="flex items-center justify-between text-sm gap-2"
                >
                  <span className="w-16 font-medium text-gray-600">
                    {day.slice(0, 3)}
                  </span>

                  {avail.available ? (
                    <div className="flex items-center gap-2 flex-1">
                      <TimePicker
                        value={avail.start ? dayjs(avail.start, "HH:mm") : null}
                        format="h:mm a"
                        onChange={(t) => handleTimeChange(day, "start", t)}
                        className="w-20 text-xs"
                      />
                      <span>-</span>
                      <TimePicker
                        value={avail.end ? dayjs(avail.end, "HH:mm") : null}
                        format="h:mm a"
                        onChange={(t) => handleTimeChange(day, "end", t)}
                        className="w-20 text-xs"
                      />
                    </div>
                  ) : (
                    <span className="text-gray-400 text-xs flex-1 text-right">
                      Unavailable
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="p-5 border-t">
        <Button
          type="primary"
          block
          className="bg-blue-600 hover:bg-blue-700"
          onClick={onNext}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
